
import _ from 'lodash';
import { Constants } from './constants';

const routeNames = {
    // 1
    'course.imposingTheStructure': '1a',
    'course.cementingTheRules': '1c',
    'course.pickingOutThePoints': '1b',
    'course.graspingTheMessage': '1d',
    // 2
    'course.ideasFitTogether': '2a',
    'course.creatingQuestion': '2b',
    // 3
    'course.deductiveReasoning': '3a1',
    'course.summarizingDeductive': '3a2',
    'course.unearthingEmbeddedArguments': '3a3',
    'course.inductiveReasoning': '3b1',
    'course.identifyingInductivePoints': '3b2',
    'course.inductionFromDeduction': '3b3',
    'course.deductionToInduction': '3b4',
    'course.avoidingDeductiveArguments': '3c',
    // 'course.supportingPoints': '3zero',
    // 4
    'course.practiceInSeeing': '4a',
    'course.findingReadersQuestion': '4b1',
    'course.spottingSCQ': '4b2',
    'course.applyingSCQProcess': '4c1',
    'course.practiceInSeeing3': '4c2',
    // 5
    'course.defineProblem': '5a',
    'course.practiceDefiningProblem': '5b',
    'course.definingMoreComplexProblems': '5c',
    'course.writingAGoodProposal': '5d'
}
export default class CourseService
{

    constructor ( apiService, $q, audioService, authService, $state )
    {
        'ngInject';

        Object.assign( this, { apiService, $q, audioService, authService, $state, routeNames } );

        this.user = null;
        this.coursesData = null
    }

    play ( effect )
    {
        this.audioService.play( effect );
    }

    getCourseData ()
    {
        const currentRoute = this.$state.current.name
        let courseId = 0

        const getCourseInfo = ( id, routeName ) =>
        {
            const course = this.coursesData.find( i => i.id === id )
            if ( !course )
            {
                return null
            }
            const unitName = this.routeNames[ routeName ]
            return course.units.find( i => i.name === unitName ) || null
        }
        if ( [
            'course.imposingTheStructure',
            'course.pickingOutThePoints',
            'course.cementingTheRules',
            'course.graspingTheMessage'
        ].includes( currentRoute ) )
        {
            courseId = 24
        } else if ( [
            'course.ideasFitTogether',
            'course.creatingQuestion'
        ].includes( currentRoute ) )
        {
            courseId = 25
        } else if ( [
            'course.deductiveReasoning',
            'course.summarizingDeductive',
            'course.unearthingEmbeddedArguments',
            'course.inductiveReasoning',
            'course.identifyingInductivePoints',
            'course.inductionFromDeduction',
            'course.deductionToInduction',
            'course.avoidingDeductiveArguments',
            // 'course.supportingPoints'
        ].includes( currentRoute ) )
        {
            courseId = 26
        } else if ( [
            'course.practiceInSeeing',
            'course.findingReadersQuestion',
            'course.spottingSCQ',
            'course.applyingSCQProcess',
            'course.practiceInSeeing3'
        ].includes( currentRoute ) )
        {
            courseId = 27
        } else if ( [
            'course.defineProblem',
            'course.practiceDefiningProblem',
            'course.definingMoreComplexProblems',
            'course.writingAGoodProposal'
        ].includes( currentRoute ) )
        {
            courseId = 28
        }
        return getCourseInfo( courseId, this.$state.current.name )
    }

    async getAll ()
    {
        const [ courses, userAnswers ] = await Promise.all( [
            this.apiService.get( {
                url: Constants.coursesUrl,
                name: 'courses'
            } ),
            this.apiService.get( {
                url: `${ Constants.exerciseAnswersUrl }?&$filter=userId eq ${ this.authService.userId }`,
                name: 'exercise_answers'
            } ),
        ] )
        const courseData = courses[ 0 ].sections
        this.coursesData = courseData
        const exercises = courseData.reduce( ( arr, item ) =>
        {
            return [ ...arr, ...item.units.reduce( ( arr, item ) => [ ...arr, ..._.get( item, 'exercises', [] ) ], [] ) ]
        }, [] )
        userAnswers.forEach( i =>
        {
            let exercise = exercises.find( item => item.id === i.exerciseId );

            if ( !exercise )
                return;

            exercise.isCompleted = true;
            exercise.userAnswers = JSON.parse( i.value );
        } )
        return courses
    }

    buildFormData ( formData, data, parentKey )
    {
        if ( data && typeof data === 'object' && !( data instanceof Date ) && !( data instanceof File ) )
        {
            Object.keys( data ).forEach( key =>
            {
                this.buildFormData( formData, data[ key ], parentKey ? `${ parentKey }[${ key }]` : key );
            } );
        } else
        {
            const value = data == null ? '' : data;

            formData.append( parentKey, value );
        }
    }

    jsonToFormData ( data )
    {
        const formData = new FormData();

        this.buildFormData( formData, data );

        return formData;
    }

    async sendUserStatistic ( dataIn )
    {
        let data = { ...dataIn, userId: this.authService.userId }
        console.log( "sendUserStatistic", data );
        const response = await this.apiService.post( {
            url: Constants.statisticsUrl,
            name: 'statistics',
            data
        } )
        return response
    }

    async sendUserAnswers ( dataIn )
    {
        let data = { ...dataIn, userId: this.authService.userId }
        console.log( "sendUserAnswers", data );
        const response = await this.apiService.post( {
            url: Constants.exerciseAnswersUrl,
            name: 'exercise_answers',
            data
        } )
        return response
    }

    getProgress ()
    {
        return this.apiService.get( {
            url: Constants.progressesUrl,
            name: 'courseProgress'
        } )
            .then( data =>
            {
                this.progresses = data;
                return data;
            } );
    }

    // Unused code
    // updateProgress ( id )
    // {
    //     return this.apiService.put( {
    //         url: Constants.progressUrl( id ),
    //         name: 'courseProgress'
    //     } )
    //         .then( data =>
    //         {
    //             this.progresses = data;
    //         } );
    // }

    //Unused code
    // postStatistic ( params )
    // {
    //     // console.log(params)
    // }

    getDiagramContainer ()
    {
        return this.apiService.get( {
            url: Constants.diagramContainersUrl,
            name: 'diagramContainers'
        } )
            .then( data =>
            {
                if ( !data.info )
                {
                    data.info = '{}';
                }
                JSON.parse( data.info );
                this.diagramContainer = {};

                return this.diagramContainer;
            } );
    }

    updateDiagramContainer ( id, data )
    {
        this.diagramContainer[ id ] = data;
        return this.apiService.put( {
            data: { 'diagram_container[info]': JSON.stringify( this.diagramContainer ) },
            url: Constants.diagramContainersUrl,
            name: 'diagramContainers'
        } )
            .then( data =>
            {
                // this.diagramContainer = JSON.parse(data.info);
            } )
            .catch( data =>
            {
                console.log( data );
            } );
    }

}



// WEBPACK FOOTER //
// ./client/app/services/course.service.js